import { commonLang } from '@umu/ukit-lang';
/**
 * @description
 * @author Kody
 * @date 2018-10-09
 */
import React, { Component, createRef, RefObject } from 'react';
import * as ua from '@umu/umu-ua';
import imageApi from '@umu/umu-image-handle';
import { $history } from '@umu/umu-dom';
import { components } from 'common';
const { If } = components;

import { getShareV2 } from '@umu/umu-api';
import { IInput as IParamInput } from '@umu/umu-api/src/services/share/getShare/models/input';
import { ShareThemeType, ShareType } from '@umu/umu-types';
import SharePicCard from '../share/@sharePicCard/sharePicCard';


interface ITheme {
    id: number;
    title: string;
    type: number; // 1: 邀请卡 2：成就卡
    preview_url: string; // 缩略图
    background_url: string;
}

interface IShareProps {
    id: string;
    studentId?: string;
    teacherId?: string;
    type: ShareType; // 类型： 1班级, 2课程, 3课程排行, 4勋章, 5大数据报告, 6学习证书， 7 学习项目， 8 小节
    width?: number; // 获取的图片宽度
    height?: number; // 获取的图片宽度
    uid?: string;

    shareImg?: string; // 可以直接传入已经有的分享卡
    title?: string;
    backDesc?: string; // 返回按钮的文案
    goBack?: () => void; // 返回的逻辑
    rightTitle?: string; // 右边按钮的文案
    rightAction?: () => void; // 右边按钮的逻辑
    rightActionDisabled?: boolean; // 右边按钮是否disabed
    imageDidUpdate?: (imgUrl: string, themeId?: number) => void; // 图片更新的回调

    themeList?: ITheme[]; // 主题
}

interface IState {
    shareImg: string;
    currentThemeId: number; // 当前 theme id
    currentThemeIndex: number; // 当前 theme 索引
    hasTheme: boolean; // 是否有主题
    isFullScreen: boolean; // 是否全屏
}

import './shareCard.scss';
import { isFromCourseMiniApp } from '../../@utils/umuUtil';
export default class ShareCard extends Component<IShareProps, IState> {
    public themeBarRef: RefObject<HTMLUListElement>;
    public cardRef: RefObject<HTMLDivElement>;
    public startX: number;
    protected taskId = 0;
    protected shareResultMap: { [name: string]: string } = {};
    private pollingImgTimer: number = 0;
    constructor(props: IShareProps) {
        super(props);
        const themeList = props.themeList || [];
        const hasTheme = themeList.length > 0;
        this.state = {
            shareImg: props.shareImg || '',
            hasTheme,
            currentThemeId: hasTheme ? themeList[0].id : 0,
            currentThemeIndex: 0,
            isFullScreen: false,
        };

        this.cardRef = createRef();
        this.themeBarRef = createRef();

        this.startX = 0;
        this.goBack = this.goBack.bind(this);
        this.touchstartHandler = this.touchstartHandler.bind(this);
        this.touchendHandler = this.touchendHandler.bind(this);
    }

    public componentDidMount() {
        const { shareImg, currentThemeId, hasTheme } = this.state;
        if (!shareImg) {
            this.fetchShareImg(currentThemeId);
        }
        if (hasTheme) {
            this.bindEvent();
        }
    }

    public componentWillUnmount() {
        clearTimeout(this.pollingImgTimer); // 清掉轮询，防止路由跳转后还在查询
        this.cardRef.current!.removeEventListener('touchstart', this.touchstartHandler);
        this.cardRef.current!.removeEventListener('touchend', this.touchendHandler);
    }

    public render() {
        const { backDesc, title = commonLang('分享'), rightTitle, rightAction } = this.props;
        const { shareImg, hasTheme, isFullScreen } = this.state;

        return (
            <div className="share-page">
                <If condition={!ua.isUMUWebview && !isFromCourseMiniApp()}>
                    <div className="share-header">
                        <div className="share-header-wrap">
                            <div className="header-action-back">
                                <i className="icon icon-arrow arrow1 size-s gray left" onClick={this.goBack} />
                                {backDesc}
                            </div>
                            <div className={`header-title ${!!rightAction ? 'has-right' : ''}`}>
                                <div className="title">{title}</div>
                            </div>
                            <If condition={!!rightAction}>
                                <div
                                    className={'header-action-right ' + (this.props.rightActionDisabled && ' disabled')}
                                    onClick={this.props.rightAction}
                                >
                                    {rightTitle}
                                </div>
                            </If>
                        </div>
                    </div>
                </If>

                <div
                    className={`share-body ${isFullScreen ? 'full-screen' : ''} ${hasTheme ? 'has-theme' : ''}`}
                    onClick={() => this.fullScreenHandle()}
                    ref={this.cardRef}
                >
                    <SharePicCard shareImage={shareImg} />
                </div>
                <If condition={hasTheme && !isFullScreen}>
                    <ul className="theme-bar clearfix" ref={this.themeBarRef}>
                        {this.renderThemeItem()}
                    </ul>
                </If>
            </div>
        );
    }

    /**
     * renderThemeItem
     */
    public renderThemeItem() {
        const { themeList = [] } = this.props;
        const currentThemeId = this.state.currentThemeId;
        return themeList.map((theme: ITheme, index) => {
            const themeId = theme.id;
            // 动态二维码缩略图
            const qrcStyle = { backgroundImage: `url(${imageApi.process(theme.preview_url)})` };
            return (
                <li
                    className={`theme-item theme-${themeId} ${currentThemeId === themeId ? 'active' : ''}`}
                    key={themeId}
                    onClick={() => this.changeThemeHandle(themeId, index)}
                    style={qrcStyle}
                >
                </li>
            );
        });
    }

    /**
     * 获取分享卡
     */
    public fetchShareImg(themeId: number) {
        const { type, id, studentId = 0, teacherId = 0, uid, width = 720, imageDidUpdate, themeList } = this.props;
        let { height } = this.props;
        const taskId = this.taskId;
        const { hasTheme, currentThemeId } = this.state;
        if (hasTheme && themeId !== currentThemeId) {
            return;
        }

        // param 索引签名
        const IInputIndex = {
            obj_type: 'obj_type',
            obj_id: 'obj_id',
            task_id: 'task_id',
            uid: 'uid',
            width: 'width',
            height: 'height',
        };
        type IKey = keyof typeof IInputIndex;

        const requiredParam: IParamInput = { obj_type: type, obj_id: id, uid, width, height, task_id: taskId };
        let params: IParamInput = { obj_type: type, obj_id: id, width };

        for (const key in requiredParam) {
            if (requiredParam.hasOwnProperty(key) && requiredParam[key as IKey]) {
                // @ts-ignore
                params[key as IKey] = requiredParam[key as IKey];
            }
        }

        if (hasTheme) {
            const currentTheme = (themeList || []).filter((theme) => {
                return theme.id === themeId;
            });
            const inviteId = currentTheme[0].type === ShareThemeType.THEME_ACHIENEMENT ? teacherId : studentId;
            height = currentTheme[0].type === ShareThemeType.THEME_ACHIENEMENT ? 1138 : 936;
            params = Object.assign({}, params, { theme_id: currentThemeId, student_id: inviteId, height });
        }

        this.setState({ shareImg: '' }); // loading
     	getShareV2(params, {
			poll_timeout_ms: 1500,
		}).then(res => {
			const picUrl = res.data.pic_url!;
			this.setState(
				{
					shareImg: picUrl,
				},
				() => {
					if (hasTheme) {
						this.shareResultMap[currentThemeId] = picUrl;
					}
					if (imageDidUpdate) {
						imageDidUpdate(picUrl, currentThemeId);
					}
				},
			);
		});
    }

    /**
     * 切换卡片主题
     * (此风格的分享卡获取过的话就直接拿来用)
     */
    public changeThemeHandle(themeId: number, index: number) {
        const themeValue = this.shareResultMap[themeId];
        const imageDidUpdate = this.props.imageDidUpdate;
        if (themeId === this.state.currentThemeId) {
            return;
        }
        if (this.props.imageDidUpdate) {
            this.props.imageDidUpdate('');
        }
        if (themeValue) {
            this.setState({
                currentThemeId: themeId,
                shareImg: themeValue,
                currentThemeIndex: index,
            });
            if (imageDidUpdate) {
                imageDidUpdate(themeValue);
            }
        } else {
            this.setState(
                {
                    currentThemeId: themeId,
                    currentThemeIndex: index,
                },
                () => {
                    this.taskId = 0;
                    this.fetchShareImg(themeId);
                },
            );
        }
    }

    /**
     * 点击全屏 (PC下足够大，不需要这个行为)
     */
    private fullScreenHandle() {
        const isMobile = ua.isMobile;
        if (isMobile && this.state.shareImg) {
            this.setState({
                isFullScreen: !this.state.isFullScreen,
            });
        }
    }

    /**
     * 返回按钮
     */
    private goBack() {
        const goBack = this.props.goBack;
        if (goBack) {
            goBack();
        } else {
            $history.go(-1);
        }
    }

    private bindEvent() {
        this.cardRef.current!.addEventListener('touchstart', this.touchstartHandler, false);
        this.cardRef.current!.addEventListener('touchend', this.touchendHandler, false);
    }

    private touchstartHandler(e: TouchEvent) {
        const isFullScreen = this.state.isFullScreen;
        if (!isFullScreen) {
            this.startX = e.touches[0].pageX;
        }
    }

    private touchendHandler(e: TouchEvent) {
        const { currentThemeId, isFullScreen, currentThemeIndex } = this.state;
        if (isFullScreen) {
            return;
        }
        const themeList = this.props.themeList || [];
        const firstThemeId = themeList[0].id;
        const lastThemeId = themeList[themeList.length - 1].id;
        let nextThemeIndex = 0;
        let nextThemeId = currentThemeId;
        const endX = e.changedTouches[0].pageX;
        if (endX - this.startX > 100 && currentThemeId !== firstThemeId) {
            nextThemeIndex = currentThemeIndex - 1;
            nextThemeId = themeList[nextThemeIndex].id;
        } else if (endX - this.startX < -100 && currentThemeId !== lastThemeId) {
            nextThemeIndex = currentThemeIndex + 1;
            nextThemeId = themeList[nextThemeIndex].id;
        } else {
            return;
        }
        this.changeThemeHandle(nextThemeId, nextThemeIndex);
        this.themeBarPositionSync(nextThemeIndex);
    }

    /**
     * touch 后的缩略图位置调整
     * @param nextThemeIndex 下一个 theme 的索引
     */
    private themeBarPositionSync(nextThemeIndex: number) {
        const themeBarRef = this.themeBarRef;
        (themeBarRef.current || { scrollLeft: 0 }).scrollLeft = nextThemeIndex * 82;
    }
}
